import { Area } from '@zoopla/listing-search/suggested-towns-and-cities';

export const newHomesTownsAndCityData: Area[] = [
    {
        id: 'in-the-city',
        headline: 'In the city',
        sub_headline: 'Live among the hustle and bustle',
        items: [
            {
                location: 'london',
                headline: 'New homes for sale in London',
                url: 'https://www.zoopla.co.uk/new-homes/property/london/'
            },
            {
                location: 'manchester',
                headline: 'New homes for sale in Manchester',
                url: 'https://www.zoopla.co.uk/new-homes/property/manchester/'
            },
            {
                location: 'leeds',
                headline: 'New homes for sale in Leeds',
                url: 'https://www.zoopla.co.uk/new-homes/property/west-yorkshire/leeds/'
            },
            {
                location: 'edinburgh',
                headline: 'New homes for sale in Edinburgh',
                url: 'https://www.zoopla.co.uk/new-homes/property/edinburgh/'
            },
            {
                location: 'cardiff',
                headline: 'New homes for sale in Cardiff',
                url: 'https://www.zoopla.co.uk/new-homes/property/cardiff/'
            },
            {
                location: 'liverpool',
                headline: 'New homes for sale in Liverpool',
                url: 'https://www.zoopla.co.uk/new-homes/property/liverpool/'
            }
        ]
    },
    {
        id: 'trending-areas',
        headline: 'Trending areas',
        sub_headline: 'See where other people are searching',
        items: [
            {
                location: 'birmingham',
                headline: 'New homes for sale in Birmingham',
                url: 'https://www.zoopla.co.uk/new-homes/property/birmingham/'
            },
            {
                location: 'glasgow',
                headline: 'New homes for sale in Glasgow',
                url: 'https://www.zoopla.co.uk/new-homes/property/glasgow/'
            },
            {
                location: 'essex',
                headline: 'New homes for sale in Essex',
                url: 'https://www.zoopla.co.uk/new-homes/property/essex/'
            },
            {
                location: 'bristol',
                headline: 'New homes for sale in Bristol',
                url: 'https://www.zoopla.co.uk/new-homes/property/bristol/'
            },
            {
                location: 'kent',
                headline: 'New homes for sale in Kent',
                url: 'https://www.zoopla.co.uk/new-homes/property/kent/'
            },
            {
                location: 'nottingham',
                headline: 'New homes for sale in Nottingham',
                url: 'https://www.zoopla.co.uk/new-homes/property/nottingham/'
            }
        ]
    }
];
